(function() { module.exports = window["jQuery"]; }());


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0
// module chunks = 84